// Общие хелперы записей календаря: статусы, эксперт записи, имена.

export const STATUS_META = {
  pending: { label: 'Ожидает подтверждения', color: '#fff4e0', textColor: '#B26A00' },
  confirmed: { label: 'Подтверждена', color: '#e3f6ec', textColor: '#009E60' },
  declined: { label: 'Отклонена', color: '#fdecec', textColor: '#EC2E2E' },
  cancelled_by_guest: { label: 'Отменена клиентом', color: '#f0f0f0', textColor: '#666' },
};

export const statusMeta = (status) => STATUS_META[status] || { label: status, color: '#f0f0f0', textColor: '#666' };

export const isCancelledStatus = (status) => status === 'declined' || status === 'cancelled_by_guest';

// Время записи прошло (встреча закончилась) — подтверждать её уже бессмысленно.
export const isPastAppointment = (appointment) => new Date(appointment.scheduled_ends_at) < new Date();

// Заявка, которую ещё можно подтвердить: ожидает и не просрочена.
export const isAwaitingConfirmation = (appointment) => appointment.status === 'pending' && !isPastAppointment(appointment);

// Эксперт записи: поле expert (ID или объект), иначе — через забронированную услугу.
export const appointmentExpertId = (appointment, services = []) => {
  const { expert } = appointment;
  if (expert && typeof expert === 'object') return expert.id;
  if (expert) return expert;
  const service = services.find((item) => item.id === appointment.service);
  return service ? service.expert : null;
};

export const expertFullName = (expert) => (expert ? `${expert.first_name || ''} ${expert.last_name || ''}`.trim() : '');

export const guestFullName = (appointment) => [appointment.guest_first_name, appointment.guest_last_name]
  .filter(Boolean)
  .join(' ');

export const initials = (name) => (name || '').split(' ')
  .filter(Boolean)
  .map((part) => part[0])
  .slice(0, 2)
  .join('')
  .toUpperCase();
